"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const mui_tel_input_1 = require("mui-tel-input");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const shallow_1 = require("zustand/shallow");
const teams_1 = require("../../../../../common/constants/teams");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../hsbc_img/status_and_notifications");
const FormLabel_1 = require("../../../../material-ui-theme/components/styled/FormLabel");
const StyledMuiTelInput_1 = require("../../../../material-ui-theme/components/styled/StyledMuiTelInput");
const companyQuery_1 = require("../../../../queries/companyQuery");
const query_keys_1 = require("../../../../queries/query-keys");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const slices_1 = require("../../../../zustandStore/slices");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../drawerAside"));
const addPeopleAside_1 = require("../addPeople/addPeopleAside");
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
function onCancelButtonClick({ setIsInvitePeopleAsideOpen, invitePeopleReset, teamId, onCloseShouldOpenAddAdminAside, setIsAddAdminAsideOpen, invitePeopleSetFirstName, invitePeopleSetLastName, setIsEmailValid, teamOwners, }) {
    return () => {
        setIsInvitePeopleAsideOpen(false);
        invitePeopleSetFirstName('');
        invitePeopleSetLastName('');
        invitePeopleReset(teamId);
        setIsEmailValid(true);
        if (onCloseShouldOpenAddAdminAside) {
            setIsAddAdminAsideOpen(teamOwners?.length > 0);
        }
    };
}
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function handleEmailChange(whiteListedDomains, setIsEmailValid, startTransition, companyFeatures, setEnableCheckUser) {
    return event => {
        if (event.target.value) {
            const enteredEmail = (event.target.value || '').trim().toLowerCase();
            startTransition(() => {
                const domain = enteredEmail.includes('@') ? enteredEmail.split('@')[1] : '';
                const isEmailInWhitelist = whiteListedDomains.includes(domain || '');
                const isEmailValidFormat = emailRegex.test(enteredEmail);
                const isEmailValid = companyFeatures?.ENABLE_DOMAIN_WHITELISTING ? isEmailInWhitelist : isEmailValidFormat;
                setIsEmailValid(isEmailValid);
                setEnableCheckUser(isEmailValid);
            });
        }
        else {
            setIsEmailValid(true);
        }
    };
}
const InvitePeopleAside = ({ tsAdmin = false, // was always set as false
teamId = '', typeId = 'roleId', role = {}, onCloseShouldOpenAddAdminAside = false, }) => {
    const [enableCheckUser, setEnableCheckUser] = (0, react_1.useState)(false);
    const saveUserSetting = (0, userQuery_1.useSaveUserSettingQuery)();
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: userSelectedTeamData } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { loggedUser, roles, isInvitePeopleAsideOpen, user, company, teamOwners, setCompanyName, setCompanyId, setInvitedUser, invitePeople, invitePeopleSetUsername, invitePeopleSetPhoneNumber, invitePeopleSetFirstName, invitePeopleSetLastName, invitePeopleSetApproverId, invitePeopleSetTeamId, invitePeopleReset, invitePeopleSetCompanyAccountId, setIsInvitePeopleAsideOpen, setIsAddAdminAsideOpen, setNotification, setUserSelectedTeam, setPageLoading, } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        setCompanyName: state.setCompanyName,
        setCompanyId: state.setCompanyId,
        setInvitedUser: state.setInvitedUser,
        invitePeopleSetUsername: state.invitePeopleSetUsername,
        invitePeopleSetPhoneNumber: state.invitePeopleSetPhoneNumber,
        invitePeopleSetFirstName: state.invitePeopleSetFirstName,
        invitePeopleSetLastName: state.invitePeopleSetLastName,
        invitePeopleSetApproverId: state.invitePeopleSetApproverId,
        invitePeopleSetTeamId: state.invitePeopleSetTeamId,
        invitePeopleReset: state.invitePeopleReset,
        invitePeopleSetCompanyAccountId: state.invitePeopleSetCompanyAccountId,
        setIsInvitePeopleAsideOpen: state.setIsInvitePeopleAsideOpen,
        setIsAddAdminAsideOpen: state.setIsAddAdminAsideOpen,
        setNotification: state.setNotification,
        setUserSelectedTeam: state.setUserSelectedTeam,
        setPageLoading: state.setPageLoading,
        loggedUser: state.user,
        roles: state.role.roles,
        invitePeople: state.invitePeople,
        isInvitePeopleAsideOpen: state.aside.invitePeopleAside.isOpen,
        user: state.invitePeople,
        company: state.company,
        teamOwners: state.team.owners,
    })));
    const loggedUserRole = roles && Object.keys(roles)?.find(roleKey => roles[roleKey][typeId] === loggedUser.roleId);
    const asideTitle = strings_1.invitePeopleStrings.INVITE_USER_TITLE(
    // ! this doesn't make sense since the user object initially has no role
    roles?.[loggedUserRole || '']?.label || (user?.role && user.role.label));
    const { data: companyFeatures } = (0, companyQuery_1.useGetCompanyFeaturesQuery)();
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId || '', { cardprovider: 'tsgo-cardprovider' }));
    const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';
    const [isEmailValid, setIsEmailValid] = (0, react_1.useState)(true);
    const { refetch: refetchGetRolesV2 } = (0, rolesQuery_1.useGetRolesV2Query)(role, tsAdmin);
    const { refetch: refetchGetTeamRolesV2 } = (0, rolesQuery_1.useGetTeamRolesV2Query)(role, tsAdmin);
    const { refetch: refetchGetAdminRolesV2 } = (0, rolesQuery_1.useGetAdminRolesV2Query)(role);
    const { data: checkedUserInfo } = (0, userQuery_1.useGetUserByEmailQuery)(user?.username, enableCheckUser);
    const sendUserInvitation = (0, userQuery_1.useSendUserInvitationQuery)();
    const { data: whitelistedDomainsData = [] } = (0, companyQuery_1.useGetCompanyPropertyWhitelistedDomainsQuery)(company.companyId);
    const whiteListedDomains = [...whitelistedDomainsData];
    const [, startTransition] = (0, react_1.useTransition)();
    const [isValidPhoneNumber, setIsValidPhoneNumber] = (0, react_1.useState)(isHsbcCardProvider ? false : true);
    (0, react_1.useEffect)(() => {
        setUserSelectedTeam(userSelectedTeamData?.[0] || '');
    }, [userSelectedTeamData, setUserSelectedTeam]);
    (0, react_1.useEffect)(() => {
        if (!teamId) {
            return;
        }
        invitePeopleSetTeamId(teamId);
    }, [teamId]);
    (0, react_1.useEffect)(() => {
        if (!userData) {
            return;
        }
        setInvitedUser(userData);
        setCompanyName(userData.companyName);
        setCompanyId(userData.companyAccountId);
        invitePeopleSetCompanyAccountId(userData.companyAccountId);
    }, [userData]);
    (0, react_1.useEffect)(() => {
        if (user?.roleId === 'company_admin') {
            invitePeopleSetApproverId('self-approval');
        }
    }, [user?.roleId]);
    const submitUserDetails = () => {
        setPageLoading(true);
        sendUserInvitation.mutate(user, {
            onSuccess(userInvited) {
                const successMessage = strings_1.invitePeopleStrings.SUCCESS_MESSAGE({
                    teamId,
                    firstName: userInvited.firstName || invitePeople.firstName || '',
                    lastName: userInvited.lastName || invitePeople.lastName || '',
                });
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: successMessage,
                    },
                ]);
                setIsInvitePeopleAsideOpen(false);
                invitePeopleReset(teamId);
            },
            onError: error => {
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: `Could not invite ${user.username}`,
                    },
                ]);
            },
            onSettled: () => {
                Root_1.queryClient.removeQueries({ queryKey: [query_keys_1.userKeys.getUserByEmail, user?.username] });
                setEnableCheckUser(false);
                setIsEmailValid(true);
                setPageLoading(false);
            },
        });
        saveUserSetting.mutate({ selectedTeamID: teamId });
    };
    (0, react_1.useEffect)(() => {
        if (user?.roleId) {
            void refetchGetAdminRolesV2();
        }
        else {
            if (tsAdmin) {
                void refetchGetRolesV2();
            }
            else {
                void refetchGetTeamRolesV2();
            }
        }
    }, [user, tsAdmin]);
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEmpty(checkedUserInfo)) {
            invitePeopleSetFirstName('');
            invitePeopleSetLastName('');
        }
        else {
            invitePeopleSetFirstName(checkedUserInfo?.firstName);
            invitePeopleSetLastName(checkedUserInfo?.lastName);
        }
    }, [checkedUserInfo]);
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "sendInvitation-button", disabled: lodash_1.default.isEmpty(user.username) ||
                    !isEmailValid ||
                    lodash_1.default.isEmpty(user.firstName) ||
                    lodash_1.default.isEmpty(user.lastName) ||
                    lodash_1.default.isEmpty(user.approverId), color: uiConstants_1.UI_BUTTON_PRIMARY, onClick: submitUserDetails, label: strings_1.inputStrings.SEND_INVITATION }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-button", onClick: onCancelButtonClick({
                    setIsInvitePeopleAsideOpen,
                    invitePeopleReset,
                    teamId,
                    onCloseShouldOpenAddAdminAside,
                    setIsAddAdminAsideOpen,
                    invitePeopleSetFirstName,
                    invitePeopleSetLastName,
                    setIsEmailValid,
                    teamOwners,
                }), color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.inputStrings.CANCEL })] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "inviteAside", title: asideTitle, open: isInvitePeopleAsideOpen, onClose: onCancelButtonClick({
            setIsInvitePeopleAsideOpen,
            invitePeopleReset,
            teamId,
            onCloseShouldOpenAddAdminAside,
            setIsAddAdminAsideOpen,
            invitePeopleSetFirstName,
            invitePeopleSetLastName,
            setIsEmailValid,
            teamOwners,
        }), footerButtons: footerButtons, children: (0, jsx_runtime_1.jsxs)(material_1.FormGroup, { sx: { margin: 1 }, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.EMAIL }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { id: slices_1.invitePeopleUsername, name: slices_1.invitePeopleUsername, required: true, type: 'email', value: user.username, onFocus: () => setEnableCheckUser(false), onChange: event => {
                                if (event.target.value) {
                                    invitePeopleSetUsername(event.target.value);
                                }
                                else {
                                    invitePeopleSetUsername('');
                                }
                            }, onBlur: handleEmailChange(whiteListedDomains, setIsEmailValid, startTransition, companyFeatures, setEnableCheckUser) }), !isEmailValid && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { p: 0 }, variant: 'outlined', icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                    color: 'error',
                                }, children: lexico.trc('Validation error message', 'Invalid email domain') }) }))] }), isHsbcCardProvider ? ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: '0 10px' }, margin: "normal", children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { id: "phoneNumber", children: "Phone Number *" }), (0, jsx_runtime_1.jsx)(StyledMuiTelInput_1.StyledMuiTelInput, { sx: { padding: 0 }, slotProps: {
                                input: {
                                    name: 'phoneNumber',
                                    required: true,
                                    autoFocus: false,
                                },
                            }, defaultCountry: "GB", onlyCountries: addPeopleAside_1.onlyCountriesCodePhoneNumbers, forceCallingCode: true, focusOnSelectCountry: true, error: Boolean(invitePeople.phoneNumberValue && !isValidPhoneNumber), MenuProps: { disableAutoFocusItem: true }, value: `${teams_1.state.phoneCountryCode}${teams_1.state.phoneNumberValue}`, onChange: (value, info) => {
                                startTransition(() => {
                                    const isValidValue = (0, mui_tel_input_1.matchIsValidTel)(value, {
                                        onlyCountries: addPeopleAside_1.onlyCountriesCodePhoneNumbers,
                                    });
                                    setIsValidPhoneNumber(isValidValue);
                                    invitePeopleSetPhoneNumber({
                                        phoneNumber: info.nationalNumber || '',
                                        phoneCountryCode: `+${info.countryCallingCode}`,
                                        phoneNumberValue: value || '',
                                    });
                                });
                            } })] })) : null, (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.FIRST_NAME }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { id: slices_1.invitePeopleFirstName, name: slices_1.invitePeopleFirstName, required: true, type: 'text', value: user.firstName, onChange: event => invitePeopleSetFirstName(event.target.value) })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.LAST_NAME }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { id: slices_1.invitePeopleLastName, name: slices_1.invitePeopleLastName, required: true, type: 'text', value: user.lastName, onChange: event => invitePeopleSetLastName(event.target.value) })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.ROLE }), (0, jsx_runtime_1.jsx)(material_1.Select, { name: slices_1.invitePeopleRoleId, disabled: !lodash_1.default.isEmpty(role), required: true, value: user?.roleId || '', inputProps: { placeholder: strings_1.inputStrings.ROLE_PLACEHOLDER }, children: roles && Object.keys(roles).length > 0
                                ? Object.keys(roles).map(roleKey => {
                                    const role = roles[roleKey];
                                    return role?.id ? ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: role.id, children: role.label }, role.id)) : ('');
                                })
                                : '' })] })] }) }));
};
exports.default = InvitePeopleAside;
